import { isChordEvent, isMarkerEvent } from '@tunasong/schemas'
import { getColorCSS, useDesignTokens } from '@tunasong/ui-lib'
import type { MouseEvent } from 'react'
import { useState } from 'react'
import type { RendererPlugin } from '../renderer.js'
import { MarkerText, Marker as StyledMarker } from './styles.js'

const getContrastText = (hex: string): string => {
  const c = hex.replace('#', '')
  const r = parseInt(c.substring(0, 2), 16)
  const g = parseInt(c.substring(2, 4), 16)
  const b = parseInt(c.substring(4, 6), 16)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.5 ? '#000' : '#fff'
}

const Marker: RendererPlugin = ({ laneHeight, event, pixelsPerSecond, onEventClick }) => {
  const tokens = useDesignTokens()
  const [textRef, setTextRef] = useState<SVGTextElement | null>(null)

  const handleEventClick = (ev: MouseEvent) => {
    if (!onEventClick) {
      return
    }
    onEventClick(ev, event)
  }

  if (!(isMarkerEvent(event) || isChordEvent(event))) {
    return null
  }

  const { color } = event
  const fill = color ? getColorCSS(color, 200) : tokens.palette.primary.main
  const textColor = fill ? getContrastText(fill) : tokens.palette.primary.contrastText

  const labelPadding = 3

  const label = event.name
  const x = event.start * pixelsPerSecond
  const y = laneHeight * 3

  if (Number.isNaN(x) || Number.isNaN(y)) {
    return null
  }

  const rectY = laneHeight * 3
  const textX = x + labelPadding
  const textY = y - labelPadding

  const bbox = textRef?.getBBox() ?? { width: 0, height: 0 }
  const rectWidth = bbox.width + 2 * labelPadding
  const rectHeight = bbox.height + 2 * labelPadding

  /** We want to have a label on  */
  return (
    <StyledMarker onClick={handleEventClick}>
      <title>{label}</title>
      <rect fill={fill} x={x} y={rectY} width={rectWidth} height={rectHeight} />
      <MarkerText ref={setTextRef} x={textX} y={textY} fill={textColor}>
        {label}
      </MarkerText>
    </StyledMarker>
  )
}

export default Marker
